import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrencyFormatService {
  // Default to Euro, fallback to en-US if not specified
  format(
    value: number,
    options?: { currency?: string; locale?: string; abbreviate?: boolean }
  ): string {
    if (value == null || isNaN(value)) return '';
    const currency = options?.currency || 'EUR';
    const locale = options?.locale || navigator.language || 'en-US';
    const abbreviate = options?.abbreviate ?? true;

    let displayValue = value;
    let suffix = '';
    if (abbreviate) {
      if (Math.abs(value) >= 1_000_000) {
        displayValue = value / 1_000_000;
        suffix = 'M';
      } else if (Math.abs(value) >= 1_000) {
        displayValue = value / 1_000;
        suffix = 'k';
      }
    }
    // Always show 0 decimals for abbreviated, else use locale default
    const minimumFractionDigits = abbreviate ? 0 : undefined;
    const maximumFractionDigits = abbreviate ? 1 : undefined;

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(displayValue);
    return formatted + suffix;
  }
}
